var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNote = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.7 120.7H118.7C114.8 120.7 111.7 117.6 111.7 113.7C111.7 109.8 114.8 106.7 118.7 106.7H174.7C178.6 106.7 181.7 109.8 181.7 113.7C181.7 117.6 178.6 120.7 174.7 120.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.7 148.8H118.7C114.8 148.8 111.7 145.7 111.7 141.8C111.7 137.9 114.8 134.8 118.7 134.8H174.7C178.6 134.8 181.7 137.9 181.7 141.8C181.7 145.7 178.6 148.8 174.7 148.8Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.7 176.8H118.7C114.8 176.8 111.7 173.7 111.7 169.8C111.7 165.9 114.8 162.8 118.7 162.8H146.7C150.6 162.8 153.7 165.9 153.7 169.8C153.7 173.6 150.6 176.8 146.7 176.8Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.8 225.8H76.6999C68.9999 225.8 62.7 219.5 62.7 211.8V71.8001C62.7 64.1001 68.9999 57.8 76.6999 57.8H216.7C224.4 57.8 230.7 64.1001 230.7 71.8001V166.9C230.7 170.6 229.3 174.1 226.6 176.8L181.6 221.8C179 224.3 175.5 225.8 171.8 225.8ZM76.6999 71.7V211.7H171.8L216.7 166.8V71.7H76.6999Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.7 225.1C170.8 225.1 167.7 222 167.7 218.1V169.7C167.7 165.8 170.8 162.7 174.7 162.7H223.1C227 162.7 230.1 165.8 230.1 169.7C230.1 173.6 227 176.7 223.1 176.7H181.7V218.1C181.7 222 178.6 225.1 174.7 225.1Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/note.de84285c.svg";
export { ForwardRef as ReactComponent };